import { Component, inject, OnInit, ElementRef, Renderer2 } from "@angular/core";
import { LoaderService } from "../services/loader.service";

@Component({
  selector: 'lib-loader',
  imports: [],
  template: `
  @if(loader.loading()){
    <div class="loader-overlay">
      <div class="loader-container">
        <div class="loading">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="loader-text">{{ loader.loadingMessage() }}</div>
      </div>
    </div>
  }
  `,
  styles: `
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.4);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      z-index: 99999;
    }
    
    .loader-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

     /* From Uiverse.io by satyamchaudharydev */
      .loading {
        --speed-of-animation: 0.9s;
        --gap: 6px;
        --first-color: var(--color-primary, #1e4cf1);
        --second-color: var(--color-success, #2dd36f);
        --third-color: var(--color-warning, #ffc409);
        --fourth-color: var(--color-danger, #eb445a);
        --fifth-color: var(--color-primary-shade, #1a43d4);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        gap: 6px;
        height: 100px;
      }

      .loading span {
      width: 4px;
      height: 50px;
      background: var(--first-color);
      animation: scale var(--speed-of-animation) ease-in-out infinite;
      }

      .loading span:nth-child(2) {
      background: var(--second-color);
      animation-delay: -0.8s;
      }

      .loading span:nth-child(3) {
      background: var(--third-color);
      animation-delay: -0.7s;
      }

      .loading span:nth-child(4) {
      background: var(--fourth-color);
      animation-delay: -0.6s;
      }

      .loading span:nth-child(5) {
      background: var(--fifth-color);
      animation-delay: -0.5s;
      }

      @keyframes scale {
      0%, 40%, 100% {
        transform: scaleY(0.05);
      }

      20% {
        transform: scaleY(1);
      }
      }
      
      .loader-text {
        font-size: 18px;
        font-weight: 700;
        color: #03002e;
        letter-spacing: 0.5px;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
      }
  `
})
export class Loader implements OnInit {
  loader = inject(LoaderService);
  el = inject(ElementRef);
  renderer = inject(Renderer2);

  ngOnInit() {
    // 🚀 Break out of app-root stacking context
    this.renderer.appendChild(document.body, this.el.nativeElement);
  }
}
